export const gridTranslations = {
    "condition-none": { 1029: "Žádná", 1033: "None" },
    "condition-equal": { 1029: "Je rovno", 1033: "Equals" },
    "condition-notequal": { 1029: "Není rovno", 1033: "Does not equal" },
    "condition-greaterthan": { 1029: "Větší než", 1033: "Greater than" },
    "condition-lessthan": { 1029: "Menší než", 1033: "Less than" },
    "condition-greaterequal": { 1029: "Větší než nebo rovno", 1033: "Greater than or equal to" },
    "condition-lessequal": { 1029: "Menší než nebo rovno", 1033: "Less than or equal to" },
    "condition-like": { 1029: "Obsahuje", 1033: "Contains" },
    "condition-notlike": { 1029: "Neobsahuje", 1033: "Does not contain" },
    "condition-null": { 1029: "Neobsahuje data", 1033: "Does not contain data" },
    "condition-notnull": { 1029: "Obsahuje data", 1033: "Contains data" },
    "condition-beginwith": { 1029: "Začíná na", 1033: "Begins with" },
    "condition-doesnotbeginwith": { 1029: "Nezačíná na", 1033: "Does not begin with" },
    "condition-endswith": { 1029: "Končí na", 1033: "Ends with" },
    "condition-doesnotendwith": { 1029: "Nekončí na", 1033: "Does not end with" },
    "condition-yesterday": { 1029: "Včera", 1033: "Yesterday" },
    "condition-today": { 1029: "Dneska", 1033: "Today" },
    "condition-tomorrow": { 1029: "Zítra", 1033: "Tomorrow" },
    "condition-last7days": { 1029: "Posledních 7 dnů", 1033: "Last 7 days" },
    "condition-next7days": { 1029: "Příštích 7 dnů", 1033: "Next 7 days" },
    "condition-lastweek": { 1029: "Minulý týden", 1033: "Last week" },
    "condition-thisweek": { 1029: "Tento týden", 1033: "This week" },
    "condition-lastmonth": { 1029: "Minulý měsíc", 1033: "Last month" },
    "condition-thismonth": { 1029: "Tento měsíc", 1033: "This month" },
    "condition-on": { 1029: "V den", 1033: "On" },
    "condition-onorbefore": { 1029: "Před dnem (včetně)", 1033: "On or before" },
    "condition-onorafter": { 1029: "Po dni (včetně)", 1033: "On or after" },
    "condition-lastyear": { 1029: "Poslední rok", 1033: "Last year" },
    "condition-thisyear": { 1029: "Tento rok", 1033: "This year" },
    "condition-lastxdays": { 1029: "Posledních X dnů", 1033: "Last X days" },
    "condition-nextxdays": { 1029: "Příštích X dnů", 1033: "Next X days" },
    "condition-lastxmonths": { 1029: "Posledních X měsíců", 1033: "Last X months" },
    "condition-nextxmonths": { 1029: "Příštích X měsíců", 1033: "Next X months" },
    "condition-contains": { 1029: "Obsahuje", 1033: "Contains" },
    "condition-infiscalperiodandyear": { 1029: "Toto fiskální období a rok", 1033: "In fiscal period and year" },
    "condition-above": { 1029: "Nad", 1033: "Above" },
    "condition-under": { 1029: "Pod", 1033: "Under" },
    "condition-notunder": { 1029: "Není pod", 1033: "Not under" },
    "condition-aboveorequal": { 1029: "Je nad nebo se rovná", 1033: "Above or equal" },
    "condition-underorequal": { 1029: "Je pod nebo se rovná", 1033: "Under or equal" },
    "condition-containvalues": { 1029: "Obsahuje hodnoty", 1033: "Contain values" },
    "condition-doesnotcontainvalues": { 1029: "Neobsahuje hodnoty", 1033: "Does not contain values" },
    "filtermenu-filterby": { 1029: "Filtrovat podle", 1033: "Filter By" },
    "filtermenu-applybutton": { 1029: "Použít", 1033: "Apply" },
    "filtermenu-clearbutton": { 1029: "Vymazat", 1033: "Clear" },
    "filtersortmenu-sorttext-a-z": { 1029: "Seřadit od A do Z", 1033: "Sort A to Z" },
    "filtersortmenu-sorttext-z-a": { 1029: "Seřadit od Z do A", 1033: "Sort Z to A" },
    "filtersortmenu-sortdate-a-z": { 1029: "Seřadit od nejstarších", 1033: "Sort older to newer" },
    "filtersortmenu-sortdate-z-a": { 1029: "Seřadit od nejnovějších", 1033: "Sort newer to older" },
    "filtersortmenu-sortnumber-a-z": { 1029: "Seřadit od nejmenších", 1033: "Sort smaller to larger" },
    "filtersortmenu-sortnumber-z-a": { 1029: "Seřadit od největších", 1033: "Sort larger to smaller" },
    "filtersortmenu-sorttwooption-a-z": { 1029: "Seřadit od nejmenších", 1033: "No to Yes" },
    "filtersortmenu-sorttwooption-z-a": { 1029: "Seřadit od největších", 1033: "Yes to No" },
    "filtersortmenu-sorttwooption-joint": { 1029: "až", 1033: "to" },
    "filtersortmenu-filterby": { 1029: "Filtrovat podle", 1033: "Filter by" },
    "filtersortmenu-clearfilter": { 1029: "Vymazat filtr", 1033: "Clear filter" },
    "paging-of": { 1029: "z", 1033: "of" },
    "paging-firstpage": { 1029: "První strana", 1033: "First page" },
    "paging-previouspage": { 1029: "Předchozí", 1033: "Previous" },
    "paging-page": { 1029: "Strana", 1033: "Page" },
    "paging-nextpage": { 1029: "Další", 1033: "Next" },
    "paging-lastpage": { 1029: "Poslední strana", 1033: "Last page" },
    "paging-pages": { 1029: "{{start}} - {{end}}", 1033: "{{start}} - {{end}}" },
    "paging-pages-totalcount": { 1029: "z {{recordcount}}", 1033: "of {{recordcount}}" },
    "norecordsfound": { 1029: 'Nenašli jsme nic, co by se zde dalo zobrazit.', 1033: 'No records found.' },
    "saving-changenotification": { 1029: "Počet upravených záznamů: <b>{{numOfChanges}}</b>.", 1033: "Number of updated records: <b>{{numOfChanges}}</b>." },
    "saving-clickreview": {1029: "Klikněte <u>zde</u> pro jejich zobrazení.", 1033: "Click <u>here</u> to review"},
    "saving-save": { 1029: "Uložit", 1033: "Save" },
    "saving-saving": { 1029: "Ukládání...", 1033: "Saving..." },
    "saving-changepreview-title": { 1033: 'Number of updated rows: {{numOfChanges}}', 1029: 'Počet upravených záznamů: {{numOfChanges}}' },
    "saving-validation-error": { 1029: 'Pro uložení záznamu je nutné opravit chybové hodnoty následujících sloupců: <b>{{columnDisplayNames}}</b>', 1033: 'Folowing columns have validation errors: <b>{{columnDisplayNames}}</b>' },
    "saving-save-all": { 1029: "Uložit všechny změny", 1033: "Save All Changes" },
    "saving-discard-all": { 1029: "Zrušit všechny změny", 1033: "Discard All Changes" },
    "saving-discard": { 1029: "Zrušit změnu", 1033: "Discard Change" },
    "saving-discard-changes": { 1029: "Zrušit změny", 1033: "Discard Changes" },
    "saving-save-changes": { 1029: "Uložit změny", 1033: "Save Changes" },
    "saving-discard-all-confirmation": { 1029: "Opravdu si přejete zrušit všechny provedené změny? Tuto akci není možné vrátit.", 1033: "Are you sure you want to discard all changes? This action cannot be reversed." },
    "validation-input-value": { 1029: 'Zadejte hodnotu', 1033: 'Please enter value.' },
    "validation-email": { 1029: 'Neplatný formát emailové adresy.', 1033: 'Invalid Email address format.' },
    "validation-url": { 1029: 'Neplatný formát webové adresy.', 1033: 'Invalid URL format.' },
    "validation-date": { 1029: 'Neplatný formát datumu.', 1033: 'Invalid Date format.' },
    "validation-number": { 1029: 'Neplatný formát čísla.', 1033: 'Invalid Number format.' },
    "no-name": { 1029: '(Bez názvu)', 1033: '(No Name)' },
    "download": { 1029: 'Stáhnout', 1033: 'Download' },
    "value-not-editable": { 1029: 'Tuto hodnotu nelze upravit.', 1033: 'This value cannot be edited.' },
    "original-value": { 1029: 'Původní hodnota', 1033: 'Previous value' },
    "new-value": { 1029: 'Nová hodnota', 1033: 'New value' }
};

